import { render } from "./CurrencyInput.vue?vue&type=template&id=6d0a9eb4"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__